var _path, _g, _g2, _g3, _g4, _path2, _path3, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 548.886,
    height: 351.951,
    viewBox: "0 0 548.886 351.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "contact",
    transform: "translate(-36.955 -60.883)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M54.717,308.057l30.369,39A55.023,55.023,0,0,0,128.5,368.27H505.337a55.022,55.022,0,0,0,38-15.225l6.488-6.193a105.536,105.536,0,0,0,16.892-131.834h0a55.028,55.028,0,0,1-7.944-34.458h0a89.036,89.036,0,0,0-69.527-95.91L405.108,66.215a230.235,230.235,0,0,0-185.973,39.677c-9.748,7.193-16.686,12.005-17.758,11.976-2.161-.059-34.6,5.081-65.7,10.106a70.163,70.163,0,0,0-58.965,68.054h0a55.027,55.027,0,0,1-16.8,38.636h0A55.026,55.026,0,0,0,54.717,308.057Z",
    transform: "translate(-0.893)",
    fill: "#a2d4f9",
    opacity: 0.35
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(65.582 94.463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M652.839,162.339a15.967,15.967,0,0,0-10.445-9.3,20.244,20.244,0,0,0-39.937-3.792,15.915,15.915,0,0,0-16.25,9.033,20.234,20.234,0,0,0-29.075,4.055Z",
    transform: "translate(-141.07 -105.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M134.711,224.731a10.726,10.726,0,0,0-7.014-6.241,13.594,13.594,0,0,0-26.819-2.547,10.84,10.84,0,0,0-1.231-.073,10.7,10.7,0,0,0-9.681,6.138,13.586,13.586,0,0,0-19.524,2.723Z",
    transform: "translate(-70.442 -115.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M240.686,114.144a7.774,7.774,0,0,1,5.086-4.525,9.856,9.856,0,0,1,19.445-1.847,7.742,7.742,0,0,1,7.912,4.4,9.852,9.852,0,0,1,14.156,1.974Z",
    transform: "translate(-95.148 -100.163)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(102.761 84.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M219.348,145.679v-8.415a3.127,3.127,0,0,0-3.127-3.127h-8.012A40.12,40.12,0,0,0,201,117.485l5.889-5.888a3.129,3.129,0,0,0,0-4.423l-5.952-5.951a3.127,3.127,0,0,0-4.423,0l-6.2,6.2a40.213,40.213,0,0,0-16.337-6.047V91.891a3.128,3.128,0,0,0-3.128-3.128h-8.415a3.128,3.128,0,0,0-3.128,3.128v10.128a40.327,40.327,0,0,0-14.9,6.832l-7.638-7.631a3.128,3.128,0,0,0-4.422,0l-5.952,5.952a3.127,3.127,0,0,0,0,4.423l7.953,7.953a40.433,40.433,0,0,0-5.774,14.587H117.059a3.127,3.127,0,0,0-3.127,3.127v8.415a3.127,3.127,0,0,0,3.127,3.127h11.512a40.39,40.39,0,0,0,5.774,14.577l-7.953,7.953a3.126,3.126,0,0,0,0,4.422l5.952,5.953a3.128,3.128,0,0,0,4.422,0l7.638-7.63a40.183,40.183,0,0,0,14.9,6.842v10.128a3.128,3.128,0,0,0,3.128,3.128h8.415a3.128,3.128,0,0,0,3.128-3.128v-9.488a40.252,40.252,0,0,0,16.337-6.057l6.2,6.2a3.129,3.129,0,0,0,4.423,0l5.952-5.952a3.128,3.128,0,0,0,0-4.422L201,165.447a40.266,40.266,0,0,0,7.209-16.64h8.012A3.127,3.127,0,0,0,219.348,145.679Zm-32.712,7.449a21.628,21.628,0,0,1-8.276,7.556,20.98,20.98,0,0,1-5.709,2.016,21.629,21.629,0,0,1-11.2-.72,21,21,0,0,1-4.733-2.271,21.583,21.583,0,0,1-7.565-8.268,21.149,21.149,0,0,1-1.694-4.374,21.651,21.651,0,0,1,0-11.195,20.929,20.929,0,0,1,1.7-4.382,21.673,21.673,0,0,1,7.556-8.268,21.034,21.034,0,0,1,4.733-2.271,21.6,21.6,0,0,1,11.2-.72,21.007,21.007,0,0,1,5.709,2.015,21.684,21.684,0,0,1,8.276,7.556,21.663,21.663,0,0,1,0,23.325Z",
    transform: "translate(-113.932 -88.763)",
    fill: "#ea5854"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M218.181,134.137H210.17a40.128,40.128,0,0,0-7.21-16.651l5.888-5.888a3.128,3.128,0,0,0,0-4.423l-5.952-5.951a3.127,3.127,0,0,0-4.423,0l-6.2,6.2a40.213,40.213,0,0,0-16.337-6.047V91.891a3.128,3.128,0,0,0-3.128-3.128h-8.415a3.128,3.128,0,0,0-3.128,3.128v10.128a40.327,40.327,0,0,0-14.9,6.832l-7.638-7.631a3.128,3.128,0,0,0-4.422,0l-5.952,5.952a3.127,3.127,0,0,0,0,4.423l7.953,7.953a40.417,40.417,0,0,0-5.774,14.587h-1.07a61.35,61.35,0,0,0,22.844,19.3,21.638,21.638,0,0,1-1.187-2,21.149,21.149,0,0,1-1.694-4.374,21.651,21.651,0,0,1,0-11.195,20.929,20.929,0,0,1,1.7-4.382,21.673,21.673,0,0,1,7.556-8.268,21.034,21.034,0,0,1,4.733-2.271,21.6,21.6,0,0,1,11.2-.72,21.007,21.007,0,0,1,5.709,2.015A21.684,21.684,0,0,1,188.6,129.8a21.663,21.663,0,0,1,0,23.325,21.636,21.636,0,0,1-6.328,6.4,60.735,60.735,0,0,0,27.312-8.078c.222-.873.425-1.753.59-2.647h3.605a61.381,61.381,0,0,0,7.533-6.148v-5.394A3.127,3.127,0,0,0,218.181,134.137Z",
    transform: "translate(-115.892 -88.763)",
    fill: "#f97068"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(143.992 89.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(0 48.047)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 68.77,
    height: 44.892,
    transform: "translate(130.223 202.191)",
    fill: "#0058c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 68.77,
    height: 19.924,
    transform: "translate(130.223 202.191)",
    fill: "#0e35af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    d: "M19.27,0H309.947a19.27,19.27,0,0,1,19.27,19.27V186.812a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V19.27A19.27,19.27,0,0,1,19.27,0Z",
    fill: "#0058c6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 306.263,
    height: 158.64,
    transform: "translate(11.477 19.428)",
    fill: "#7db6f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    d: "M0,0H329.217a0,0,0,0,1,0,0V13.832a19.27,19.27,0,0,1-19.27,19.27H19.27A19.27,19.27,0,0,1,0,13.832V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 178.068)",
    fill: "#57aff7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 6.23,
    cy: 6.23,
    r: 6.23,
    transform: "translate(158.379 189.732)",
    fill: "#0058c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M456.989,446.185H208.924a4.138,4.138,0,0,1-4.138-4.138h0a12.1,12.1,0,0,1,12.1-12.1H449.026a12.1,12.1,0,0,1,12.1,12.1h0A4.138,4.138,0,0,1,456.989,446.185Z",
    transform: "translate(-168.348 -190.984)",
    fill: "#57aff7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(24.9 33.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(211.523 9.871)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 67.893,
    height: 16.982,
    rx: 2.192,
    fill: "#afd9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(5.36 4.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M449.194,213.1l-2.6,1.189.328-2.839-1.934-2.1,2.8-.565,1.4-2.49,1.4,2.49,2.8.565-1.934,2.1.328,2.839Z",
    transform: "translate(-444.99 -206.287)",
    fill: "#ff777a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M463.455,213.1l-2.6,1.189.328-2.839-1.934-2.1,2.8-.565,1.4-2.49,1.4,2.49,2.8.565-1.934,2.1.328,2.839Z",
    transform: "translate(-447.059 -206.287)",
    fill: "#ff777a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M477.715,213.1l-2.6,1.189.328-2.839-1.934-2.1,2.8-.565,1.4-2.49,1.4,2.49,2.8.565-1.934,2.1.328,2.839Z",
    transform: "translate(-449.129 -206.287)",
    fill: "#ff777a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M491.975,213.1l-2.6,1.189.328-2.839-1.934-2.1,2.8-.565,1.4-2.49,1.4,2.49,2.8.565-1.934,2.1.328,2.839Z",
    transform: "translate(-451.198 -206.287)",
    fill: "#ff777a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M506.235,213.1l-2.6,1.189.328-2.839-1.934-2.1,2.8-.565,1.4-2.49,1.4,2.49,2.8.565-1.934,2.1.328,2.839Z",
    transform: "translate(-453.267 -206.287)",
    fill: "#f7f7f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 75.885,
    height: 23.601,
    rx: 4.384,
    fill: "#afd9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(3.976 3.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 6.616,
    cy: 6.616,
    r: 6.616,
    transform: "matrix(0.384, -0.923, 0.923, 0.384, 0, 12.216)",
    fill: "#ff777a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M200.865,207.534a6.588,6.588,0,0,0,8.884,0,4.459,4.459,0,0,0-2.781-3.786,2.752,2.752,0,1,0-3.322,0A4.459,4.459,0,0,0,200.865,207.534Z",
    transform: "translate(-196.655 -193.988)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(20.07 5.198)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 35.266,
    height: 1.263,
    fill: "#dcf1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 45.828,
    height: 1.263,
    transform: "translate(0 2.822)",
    fill: "#dcf1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 45.828,
    height: 1.263,
    transform: "translate(0 5.644)",
    fill: "#dcf1ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(0 32.928)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 43.278,
    height: 10.825,
    rx: 2.192,
    fill: "#afd9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 43.278,
    height: 10.825,
    rx: 2.192,
    transform: "translate(0 15.295)",
    fill: "#afd9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 43.278,
    height: 10.825,
    rx: 2.192,
    transform: "translate(0 30.589)",
    fill: "#dcf1ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 43.278,
    height: 10.825,
    rx: 2.192,
    transform: "translate(49.858 15.295)",
    fill: "#ff777a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 43.278,
    height: 10.825,
    rx: 2.192,
    transform: "translate(49.858 30.589)",
    fill: "#afd9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(236.139 53.635)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 43.278,
    height: 10.825,
    rx: 2.192,
    fill: "#ff777a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 43.278,
    height: 10.825,
    rx: 2.192,
    transform: "translate(0 15.295)",
    fill: "#afd9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 43.278,
    height: 10.825,
    rx: 2.192,
    transform: "translate(0 30.589)",
    fill: "#dcf1ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(67.544 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(33.638 69.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M292.035,184.1c-1.953,49.351-24.9,54.347,0,89.948s110.676,22.987,112.134-3.965-16.655-43.19-4.787-76.916S292.035,184.1,292.035,184.1Z",
    transform: "translate(-280.521 -175.404)",
    fill: "#252384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M300.15,197.917c-2.893,22.43-10.589,44.551-6.636,56.709,0,0,.433-13.679,2.994-16.975,0,0-2.557,19.2,5.275,34.774s92.378,12.607,92.378,12.607,1.73-17.057,0-29.417-5.026-17.163-5.974-23.784c0,0,5.212,10.765,7.241,14.884s2.3,10.159,2.3,10.159.551-10.984-3.734-19.388-1.715-31.581-.445-40.593-59.635-19.7-66.264-16.087S300.15,197.917,300.15,197.917Z",
    transform: "translate(-282.246 -176.084)",
    fill: "#0c0835"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(0 114.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M312.353,271.911c-29.386,9.954-50.465,13.7-56.555,32.907s-14.626,41.045-14.626,41.045H439.889s-9.837-45.26-20.61-52.755-52.933-20.053-65.814-22.206S312.353,271.911,312.353,271.911Z",
    transform: "translate(-241.172 -234.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M418.868,323.1s.75,18.017-1.883,30.447h6.736Z",
    transform: "translate(-266.686 -242.238)",
    fill: "#dcedff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M296.246,331.4s-.574,13.817,1.445,23.348h-5.166Z",
    transform: "translate(-248.624 -243.443)",
    fill: "#dcedff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M265.167,301.779c2.575-6.789,10.886-14.758,10.895-14.766-10.085,4.638-17.145,10.416-20.263,20.252-6.089,19.206-14.626,41.045-14.626,41.045H257.2C256.5,327.855,262.59,308.571,265.167,301.779Z",
    transform: "translate(-241.172 -237.002)",
    fill: "#dcedff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M359.744,308.108s-14.288-.937-22.954-7.495S329.3,287.5,329.3,287.5s-6.324.468-8.666,0,1.021-24.872,14.681-25.317,42.271,5.22,45.785,5.41,15.1,10.576,12.178,23.736c-.468,2.108-6.127-3.828-8.7-.783S379.886,306.469,359.744,308.108Z",
    transform: "translate(-252.603 -233.394)",
    fill: "#0058c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M356.67,304.474a72.038,72.038,0,0,1-24.888-34.115c-1.223-3.576.843-5.575,4.638-6.183Z",
    transform: "translate(-254.27 -233.688)",
    fill: "#0e35af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M367.348,308.805c10.048-6.431,19.3-22.241,22.111-27.51s2.923-10.23-5.682-11.146S367.348,308.805,367.348,308.805Z",
    transform: "translate(-259.482 -234.552)",
    fill: "#0e35af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M380.323,232.047c-2.588,20.894-4.071,32.066,2.917,40.731,0,0-12.452,25.3-21.352,30.448,0,0-21.314-15.224-27.169-39.582a29.715,29.715,0,0,0,3.981-13.351c.468-7.963-.7-21.782-.7-21.782Z",
    transform: "translate(-254.747 -228.512)",
    fill: "#ffc5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M376.363,297.065c-13,15.738-26.391,2.455-31.366-4.293a81.536,81.536,0,0,0,18.383,19.779C367.475,310.179,372.322,303.541,376.363,297.065Z",
    transform: "translate(-256.239 -237.837)",
    fill: "#fe8a8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M338.735,250.346a30.257,30.257,0,0,1-3.776,13.011c9.641-1.711,30.326-5.676,43.293-10.3.2-5.728,1.065-12.556,2.106-20.959l-25.819-2.156-16.48-1.071C338.225,230.934,339.163,243.077,338.735,250.346Z",
    transform: "translate(-254.782 -228.564)",
    fill: "#fe8a8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(38.916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(99.336 21.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M424.476,162.9c.828-13.177,1.046-25.167-9.238-40.534s-8.11,25.186-7.942,25.65,9.116,17.564,9.116,17.564Z",
    transform: "translate(-403.488 -118.892)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M420.557,192.558c-1.306,7.579-.421,13.835,3.212,14.461s7.637-5.01,8.943-12.587-.581-14.23-4.215-14.855S421.863,184.979,420.557,192.558Z",
    transform: "translate(-405.373 -127.692)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M428.049,200.374l-2.288.93-2.242,6.212s-.38.77-.847,1.76a3.18,3.18,0,0,0,1.487.7c3.219.555,6.726-3.812,8.392-10.086C429.661,201.389,428.049,200.374,428.049,200.374Z",
    transform: "translate(-405.763 -130.646)",
    fill: "#cb3034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M414.714,167.478c2.819-.522,10.813,1.6,11.72,5.727,2.064,9.39-1.364,31.172-7.655,36.55-2.293,1.959-8.676,1.561-10.942.865-5.749-1.765-5.768-10.957-3.667-23.153S410.8,168.2,414.714,167.478Z",
    transform: "translate(-402.893 -125.931)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M425.2,200.457c-2.925,2.11-4.445,0-4.445,0-1.983,4.217-5.629,4.214-10.23,4.838l-2.581-1.365s-2.521,1.854-4.886,3.531c.426,4.2,1.86,7.053,4.8,7.956,2.265.7,8.649,1.094,10.942-.865C421.561,212.2,423.767,206.69,425.2,200.457Z",
    transform: "translate(-402.917 -130.728)",
    fill: "#cb3034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M427.6,173.2c-.907-4.13-8.9-6.249-11.72-5.727a4.3,4.3,0,0,0-.706.2c5.166-.383,7.871,3.233,8.464,7.375s0,22.887-6.082,31.155c-.775,1.055-2.118,4.135-6.638,4.79,2.871.378,7.219.3,9.028-1.245C426.235,204.377,429.663,182.595,427.6,173.2Z",
    transform: "translate(-404.057 -125.931)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M426.343,200.457c-2.925,2.11-4.445,0-4.445,0l0,0a29.969,29.969,0,0,1-4.342,10.546c-.775,1.055-2.118,4.135-6.638,4.79,2.871.378,7.219.3,9.028-1.245C422.7,212.2,424.907,206.69,426.343,200.457Z",
    transform: "translate(-404.057 -130.728)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M416.029,190.747c-1.14,6.616-3.5,11.732-5.272,11.426s-2.283-5.916-1.143-12.532,3.5-11.732,5.271-11.426S417.169,184.131,416.029,190.747Z",
    transform: "translate(-403.78 -127.499)",
    fill: "#cb3034"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M312.746,204.63q.119.289.245.577c2.884,6.642,8.078,13.558,13.162,18.737,7.514,7.656,17.711,14.312,28.522,15.761,11.62,1.558,22.279-4.906,30.052-13.2a29.888,29.888,0,0,0,7.515-13.641c1.225-5.449.56-11.289,1.451-16.857a50.107,50.107,0,0,1,2.693-8.67,63.706,63.706,0,0,0,3.591-27.993c-.444-3.917-1.083-9.533-3.2-12.93-2.438-3.905-8.076-6.978-11.881-9.358-12.2-7.632-28.365-10.427-42.224-6.112-14.168,4.411-25.72,15.768-31.689,29.2-2.841,6.393-4.492,12.685-3.113,19.575C309.585,188.3,309.325,196.357,312.746,204.63Z",
    transform: "translate(-289.695 -99.252)",
    fill: "#ffc5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M310.336,173.249s22.016,6.049,41.455,0,26.037-18.229,27.657-24.553c0,0,15.879,12.45,19.054,30.817,0,0,1.091-32.612-9.042-36.673s-31.345-9.368-33.687-7.261-41.69,24.592-41.69,24.592Z",
    transform: "translate(-290.125 -100.15)",
    fill: "#fe8a8b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(42.618 70.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M336.547,179.66a43.682,43.682,0,0,1,4.964-2.043,27.306,27.306,0,0,1,5.32-1.217,14.857,14.857,0,0,1,5.545-.015c2.641.72,3.695,1.249,4.979,2.467l-.088.241a24.954,24.954,0,0,1-2.715-.033l-2.561-.139c-1.673-.064-3.318-.471-5.031-.474a33.918,33.918,0,0,0-5.146.416c-1.731.24-3.449.643-5.181,1.039Z",
    transform: "translate(-336.547 -176.122)",
    fill: "#0c0835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M400.043,180.243a19.809,19.809,0,0,0-5.075-1.422,27.083,27.083,0,0,0-5.188-.26c-1.735.08-3.4.548-5.11.651a50.165,50.165,0,0,1-5.358.227l-.088-.241a12.25,12.25,0,0,1,5.012-2.514,16.092,16.092,0,0,1,5.582-.174,23.2,23.2,0,0,1,5.448,1.064,18.219,18.219,0,0,1,4.905,2.446Z",
    transform: "translate(-342.74 -176.156)",
    fill: "#0c0835"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 1.673,
    cy: 3.42,
    rx: 1.673,
    ry: 3.42,
    transform: "translate(9.034 9.974)",
    fill: "#0c0835"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 1.607,
    cy: 3.42,
    rx: 1.607,
    ry: 3.42,
    transform: "translate(44.297 10.138)",
    fill: "#0c0835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M374.253,211.028a6.4,6.4,0,0,1-2.483,3.17,4.355,4.355,0,0,1-3.92.415c-2.033-.859-2.594-3.232.173-2.7a9.523,9.523,0,0,0,3.208.184C371.8,212.021,374.009,211.661,374.253,211.028Z",
    transform: "translate(-340.84 -181.188)",
    fill: "#fe8a8b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(13.263 39.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M352.062,221.9a254.278,254.278,0,0,0,29.226,1.038c-2.243,7.438-7.76,14.727-15.32,14.459C358.211,237.123,353.7,229.656,352.062,221.9Z",
    transform: "translate(-352.062 -221.901)",
    fill: "#c31f2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M375.935,235.108c-5.837-4.916-10.05-.71-10.05-.71-1.329-.9-5.01-2.43-8.242-.245a12.642,12.642,0,0,0,6.742,4.468c.845.115,1.724.232,2.606.342A12.492,12.492,0,0,0,375.935,235.108Z",
    transform: "translate(-352.872 -223.471)",
    fill: "#fb8384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M354.181,222.137a17.989,17.989,0,0,0,.737,3.673,40.451,40.451,0,0,0,23.732,1.224,40.087,40.087,0,0,0,.646-3.994C373.007,223.135,360.94,222.8,354.181,222.137Z",
    transform: "translate(-352.37 -221.935)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(84.045 103.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M403.121,235.5a7.723,7.723,0,0,1-1.66-.041c-5.32-.721-8.17-1.118-8.17-1.118l.326-2.332s2.848.4,8.161,1.116c4.9.669,11.181-7.116,12.839-16.268a1.186,1.186,0,0,1,1.321-.981h0a1.172,1.172,0,0,1,1.005,1.352C415.22,226.885,408.883,235.038,403.121,235.5Z",
    transform: "translate(-386.208 -215.863)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M416.664,216.339a1.162,1.162,0,0,1-.015.254c-1.722,9.658-8.059,17.811-13.822,18.271a7.725,7.725,0,0,1-1.66-.041c-4.2-.568-6.852-.935-7.786-1.065l-.091.65s2.85.4,8.17,1.118a7.779,7.779,0,0,0,1.66.041c5.762-.46,12.1-8.613,13.821-18.271A1.135,1.135,0,0,0,416.664,216.339Z",
    transform: "translate(-386.208 -215.932)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M392.218,237.928l-4.667-.639a2.944,2.944,0,0,1-2.518-3.316h0a2.945,2.945,0,0,1,3.316-2.518l4.667.639a2.943,2.943,0,0,1,2.518,3.316h0A2.943,2.943,0,0,1,392.218,237.928Z",
    transform: "translate(-385.006 -218.122)",
    fill: "#252384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M394.852,233.4a2.885,2.885,0,0,1-.021.58h0a2.943,2.943,0,0,1-3.316,2.518l-4.084-.559a2.931,2.931,0,0,1-2.347-1.891c-.015.072-.041.139-.051.213h0a2.944,2.944,0,0,0,2.518,3.316l4.667.639a2.943,2.943,0,0,0,3.316-2.517h0A2.925,2.925,0,0,0,394.852,233.4Z",
    transform: "translate(-385.006 -218.408)",
    fill: "#261b60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(4.52 0.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M384,137.59s23.422,9.837,23.655,41.923c0,0,18.737-20.61,7.73-51.526s-42.861-29.745-42.861-29.745Z",
    transform: "translate(-303.67 -95.019)",
    fill: "#252384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M385.781,143.374s22.844,9.616,23.621,40.787c0-.18,0-.351,0-.536-.382-31.45-11.285-39.8-22.059-45.532l-2.565,1.837Z",
    transform: "translate(-305.448 -100.803)",
    fill: "#261b60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M306.345,165.617s64.565,3.748,69.717-29.042-11.4-40.748-19.518-41.534S332.6,92.376,319.071,105.5s-28.642,21.079-26.96,63.549Z",
    transform: "translate(-291.981 -94.473)",
    fill: "#252384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M307.216,163.428c2.815-1.567,5.625-3.174,8.343-4.946q4.1-2.617,8.045-5.5a169.617,169.617,0,0,0,15.165-12.386,170.386,170.386,0,0,1-13.99,13.845q-3.688,3.283-7.593,6.337c-2.585,2.06-5.29,3.974-8.029,5.86Z",
    transform: "translate(-294.192 -101.166)",
    fill: "#0c0835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M343.952,110.638c-15.3,8.275-32.122,28.179-32.448,44.665,0,0-6.469-6-3.067-14.614s13.418-18.146,18.967-22.244S343.952,110.638,343.952,110.638Z",
    transform: "translate(-294.226 -96.819)",
    fill: "#0c0835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M310.19,158.567c-2.05-5.311-.645-23.438,0-28.591a48.286,48.286,0,0,1,2.752-10.041c.205-.966-.239-1.258-.239-1.258,10.652-16.394,25.769-18.739,41.1-23.534l-.881-.435c-8.663-.686-22.112-.587-33.846,10.795-13.534,13.127-28.642,21.079-26.96,63.549l14.235-3.435s22.08,1.278,41.446-4.215C326.257,165.632,312.238,163.878,310.19,158.567Z",
    transform: "translate(-291.981 -94.473)",
    fill: "#0c0835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M369.59,143.6c-6.328,9.878-14.159,19.1-44.053,23.39-19.915,2.86-23.063-1.226-23.063-1.226s34.759-2.315,48.8-9.441S369.59,143.6,369.59,143.6Z",
    transform: "translate(-293.504 -101.603)",
    fill: "#0c0835"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M312.473,119.419c3.869-11.32,23.266-24.1,45.75-24.415a46.667,46.667,0,0,0-24.982,2.186c-13.428,5-23.094,13.146-28.41,22.343S312.473,119.419,312.473,119.419Z",
    transform: "translate(-289.141 -94.216)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M332.2,100.384a45.141,45.141,0,0,0-19.127,15.341c-.62.078-6.229,1.122-6.316,1.139-.639.922-1.244,1.854-1.791,2.8-.191.33-.352.631-.5.915,1.759-.121,4.337-.238,5.018.064a3.163,3.163,0,0,0,1.711-.129c.844-.557,1.411-.964,1.411-.964,3.869-11.32,23.266-24.1,45.75-24.415C350.788,95.039,344.494,95.466,332.2,100.384Z",
    transform: "translate(-289.273 -94.348)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M308.658,163.321c-1.059-21.031,1.912-35.375,4.567-39.278s-8.238-2.206-10.424.858c-1.417,1.986-6.208,18.714-4.45,38.566S308.658,163.321,308.658,163.321Z",
    transform: "translate(-288.331 -98.216)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M311.3,121.776c.935.355,1.208.823.545,1.838s-3.4,9.915-4.1,17.761-.351,16.082-.507,17.019-7.024,2.666-9.094,1.724c.06,1.106.136,2.222.236,3.349.13,1.466.3,2.709.495,3.764,2.086.235,4.981.339,7.626.379a42.239,42.239,0,0,0,2.187-4.289c-1.059-21.031,1.912-35.375,4.567-39.278C314.323,122.465,313.181,121.8,311.3,121.776Z",
    transform: "translate(-288.355 -98.216)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M306,169.141c-2.75-.81-10.92.475-12.248,4.489-3.02,9.128-1.853,31.148,3.851,37.145,2.078,2.185,8.468,2.445,10.794,1.987,5.9-1.163,6.866-10.306,6.031-22.652S309.813,170.264,306,169.141Z",
    transform: "translate(-287.484 -105.056)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M297.846,213.777c2.078,2.185,8.468,2.445,10.794,1.987,3.391-.669,5.146-3.982,5.872-9.015-2.837,2.435-10.093,1.655-13.76,0,0,0,.6-10.962-1.34-17.145a135.335,135.335,0,0,0-5.586,14.777C294.733,208.484,296.069,211.908,297.846,213.777Z",
    transform: "translate(-287.729 -108.058)",
    fill: "#cb3034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M304.73,191.145c.745,11.028-1.859,20.185-5.817,20.452s-7.77-8.456-8.515-19.484,1.858-20.185,5.817-20.452S303.985,180.117,304.73,191.145Z",
    transform: "translate(-287.214 -105.454)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M300.091,199.881s-5.057.631-7.007,8.283c1.633,4.712,3.908,7.686,6.238,7.529,2.013-.136,3.673-2.58,4.723-6.393a16.987,16.987,0,0,1-3.4-1.063S301.089,206.455,300.091,199.881Z",
    transform: "translate(-287.622 -109.55)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M299.056,193.445c.558,8.26-.935,14.852-4.614,15.1s-7.112-6.246-7.67-14.506,1.971-15.157,5.648-15.4S298.5,185.185,299.056,193.445Z",
    transform: "translate(-286.694 -106.466)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M293.872,208.771c-1.679.114-3.314-.881-4.763-2.667,1.458,3.488,3.526,5.672,5.683,5.526,3.164-.214,4.706-5.125,4.722-11.749C298.729,205.094,296.864,208.569,293.872,208.771Z",
    transform: "translate(-287.045 -109.55)",
    fill: "#cb3034"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(429.663 146.152)"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(0 14.599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(5.905 16.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M503.382,246.417c-.764,2.811,1.656,5.309,2.437,5.777s6.089,2.654,9.369,2.733,8.119-6.871,6.4-7.651-13.741-1.64-15.067-1.64A10,10,0,0,0,503.382,246.417Z",
    transform: "translate(-503.235 -203.92)",
    fill: "#ffc5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M513.609,243.065c.82,8.432,3.748,14.989,4.8,15.107s11.516-3.4,14.424-4.684.67-21.077-1.106-20.728-5.893,4.15-9.2,5.973S513.609,243.065,513.609,243.065Z",
    transform: "translate(-504.74 -202.051)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M530.582,248.915c-1.107,1.688-9.529,5.965-14.11,7.524.922,2.49,1.852,4.022,2.354,4.078.9.1,8.7-2.46,12.751-4.008A58.123,58.123,0,0,0,530.582,248.915Z",
    transform: "translate(-505.156 -204.396)",
    fill: "#dcedff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M503.423,240.009c-.324,3.345,2.654,3.826,6.324,2.966S519.9,234,522.784,230.328s8.256-10.208,9.31-10.794,3.4-.9,5.622-4.2.117-10.208-.762-11.028-9.115,1.917-10.149,3.3.02,8.82-.332,9.757-7.749,8.588-10.872,10.461S503.657,237.588,503.423,240.009Z",
    transform: "translate(-503.259 -197.901)",
    fill: "#ffc5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M536.591,210.409c.979-.468,1.363-2.6.74-2.221a6.5,6.5,0,0,1-3.067.348,11.634,11.634,0,0,1-1.974-.141,12.557,12.557,0,0,0-.259,1.677S535.611,210.877,536.591,210.409Z",
    transform: "translate(-507.414 -198.479)",
    fill: "#fe8a8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M539.962,211.041c-.5-1.065-.88-1.873-.88-1.873l-5.916,5.322a31.311,31.311,0,0,0-3.179-2.507l-.55.868a16.664,16.664,0,0,1,1.292,5.5s.781.937,1.249,1.015c0,0-6.6,9.369-10.735,13.975-4.114,4.579-6.991,8.539-8.866,9.812,3.747-2.073,9.143-8.833,11.709-12.092,2.889-3.67,8.256-10.208,9.31-10.794s3.4-.9,5.622-4.2A8.133,8.133,0,0,0,539.962,211.041Z",
    transform: "translate(-504.562 -198.628)",
    fill: "#fe8a8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M531.137,209.786c.027.546,5.175,5.309,5.711,5.856a.823.823,0,0,0,.591,0c1.555-1.284,8.779-12.871,8.923-13.289.134-.39-3.811-4.375-5.028-5.441a1.168,1.168,0,0,0-1.029.119C538.859,198.963,531.1,209.081,531.137,209.786Z",
    transform: "translate(-507.284 -196.839)",
    fill: "#0c0835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M531.828,209.793c.027.546,5.175,5.309,5.711,5.856s9.358-12.837,9.513-13.289c.135-.39-4.3-4.31-5.511-5.377a.37.37,0,0,0-.545.055C539.549,198.971,531.793,209.088,531.828,209.793Z",
    transform: "translate(-507.384 -196.846)",
    fill: "#252384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M532.977,209.019c.026.51,4.841,4.966,5.342,5.477s8.754-12.009,8.9-12.432c.126-.365-4.019-4.032-5.157-5.03a.346.346,0,0,0-.51.05C540.2,198.893,532.944,208.359,532.977,209.019Z",
    transform: "translate(-507.551 -196.854)",
    fill: "#57aff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M537,202.738a6.793,6.793,0,0,0,2.2-2.836c.137-.586.117-1.112-.332-1.229s-1.991,1.717-2.732,2.264-1.679,1.679-1.386,2.44,1.873.468,2.049.351S537,202.738,537,202.738Z",
    transform: "translate(-507.799 -197.104)",
    fill: "#ffc5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M539.3,198.854c.221.666-1.731,3.337-3.328,4.106l.525.656s.264-.058.6-.137a4.727,4.727,0,0,0,.083-.714,6.792,6.792,0,0,0,2.2-2.836A1.273,1.273,0,0,0,539.3,198.854Z",
    transform: "translate(-507.985 -197.131)",
    fill: "#fe8a8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M534.48,206.108a17.394,17.394,0,0,1,3.482-1.016c.82-.322,1.054-1.552.527-1.757a14.55,14.55,0,0,0-4.743.7c-.879.38-1.412,2.134-1.412,2.134Z",
    transform: "translate(-507.458 -197.775)",
    fill: "#ffc5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M535.364,205.362a1.857,1.857,0,0,1-1.112,0c0,.323-.317.485-.7.945l1.1-.032a17.394,17.394,0,0,1,3.482-1.016,1.312,1.312,0,0,0,.733-.824C538.468,205.109,536.2,205.207,535.364,205.362Z",
    transform: "translate(-507.635 -197.941)",
    fill: "#fe8a8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M530.778,207.962c.7,1.081,4.567.613,5.348.5s1.3-.605,1.258-1.1c-.086-.992-5.161-.816-5.591-.66S530.778,207.962,530.778,207.962Z",
    transform: "translate(-507.232 -198.252)",
    fill: "#ffc5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M537.56,207.773a6.015,6.015,0,0,1-3.222.928,12.992,12.992,0,0,1-2.033.037,15.959,15.959,0,0,0,4.043-.106A1.4,1.4,0,0,0,537.56,207.773Z",
    transform: "translate(-507.453 -198.425)",
    fill: "#fe8a8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(0 108.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(47.809 118.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M552.856,466.514c.233,2.049,1.053,2.811,4.04,3.22s7.378.351,9.661-1.874,3.689-4.8,3.864-5.914a11.3,11.3,0,0,1,.468-2.927c.351-.586,2.209-.951,1.98-4.216S552.856,466.514,552.856,466.514Z",
    transform: "translate(-552.34 -444.174)",
    fill: "#ffdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M572.1,445.323c-.336-4.534-11.081-2.784-11.14-.969s-2.576,9.427-5.049,11.738l0,.005c-3.237,1.472-4.457,5.158-3.15,8.692,1.109,3,9.427,2.272,11.418,1.171a13.392,13.392,0,0,0,4.8-5.846h0a13.582,13.582,0,0,1,1.643-3.639c1-1.23,1.523-1,1.991-2.46S572.442,449.857,572.1,445.323Z",
    transform: "translate(-552.252 -442.449)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M564.271,445.434c-1.034,4.676-3.263,7.721-2.61,8.265s4.676,1.2,5.437,0a25.923,25.923,0,0,0,2.066-8.265C569.164,443.423,564.271,445.434,564.271,445.434Z",
    transform: "translate(-553.6 -442.752)",
    fill: "#ffdcdc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(0 110.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M531.033,447.729a14.029,14.029,0,0,0-1.429-8.418c-1.724-3.4-1.64-3.689-3.631-4.04s-9.251-1.346-9.251-1.346a12.036,12.036,0,0,1-5.5,5.738c-4.274,2.342-5.152,3.161-7.9,3.161s-8.834.324-6.441,7.612c0,0,1.932.839,6.772.8s9.758-.429,11.515-1.093,3.591-1.015,4.645-.586,4.489.274,6.441,0A18.374,18.374,0,0,0,531.033,447.729Z",
    transform: "translate(-496.327 -433.924)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M510.01,441.165a.478.478,0,0,0-.241.721c.576.894,1.775,1.874,2.413,1.651a45.328,45.328,0,0,0,6.324-4.684c.9-.781,1.757-2.265,1.249-2.966s-1.835-1.523-2.381-1.093-1.6,2.489-3.826,4.328A11.261,11.261,0,0,1,510.01,441.165Z",
    transform: "translate(-498.266 -434.033)",
    fill: "#ffdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M496.966,452.77a90.769,90.769,0,0,0,18.118-1.053c2.258-.586,3.487-1.582,5.654-.762s8.841-.468,9.9-.878.761,1.24,0,1.41-5.563,1.186-8.022,1.411-2.576-1.591-5.5-.244S509.379,454,507.271,454s-8.138.469-9.252,0S496.966,452.77,496.966,452.77Z",
    transform: "translate(-496.419 -436.259)",
    fill: "#ffdcdc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M555.14,425.368c3.284.9,12.648.586,13.116-.7s-1.287-21.548-1.287-27.989-2.225-22.367-1.874-24.124a13.763,13.763,0,0,0-.234-6.089c-.586-3.045-.816-38.333-3.631-62.105l-36.537,3.436s-5.855,22.484-6.324,38.411.078,23.577,0,25.919,1,4.684,1.24,6.558-.068,15.771-.381,20.767-.539,14.209-1.051,15.3,11.044,3.279,12.605,2.5,1.562-.937,1.562-9.056,1.093-27.637,1.093-31.072,1.093-4.06.625-5.777,1.249-9.525,2.966-15.3,3.748-12.022,3.748-12.022,4.84,31.228,6.4,33.1,1.249,6.714,2.186,9.524,3.748,21.86,3.748,27.637S551.7,424.431,555.14,425.368Z",
    transform: "translate(-499.495 -304.358)",
    fill: "#0e35af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M565.331,425.826a22.63,22.63,0,0,0,4.02-.491c.39-1.666.805-3.763,1.237-6.2-.36-6.817-1.209-17.979-1.209-22.459,0-6.441-2.225-22.367-1.874-24.124a13.762,13.762,0,0,0-.234-6.089c-.586-3.045-.816-38.333-3.631-62.105l-7.352.692-21.515,8.091a163.973,163.973,0,0,0,22.432-1.334s1.682,19.034,1.739,21.844,2.087,29.053,2.087,31.468.937,3.113,1.093,5.73a3.619,3.619,0,0,1-1.874,3.555s2.811.937,2.811,1.405.586,8,.586,10.931,1.276,6.909,1.633,15.692,1.529,19.2,1.529,20.376C566.808,423.951,566.8,425.141,565.331,425.826Z",
    transform: "translate(-501.906 -304.358)",
    fill: "#001e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M540.2,329.7l-7.846-1.991,6.09,2.928-4.919.117L537.3,332.1s1.175,9.785-1.27,16.338c-2.681,7.183-3.9,25.529-4.723,26.934s-2.928,1.054-2.928,1.054,2.225.234,2.342,1.874-.468,6.206-.468,11.047a147.857,147.857,0,0,1-.937,15.784c-.468,3.266-.687,11.256-.937,13.38s-3.441,1.627-3.441,1.627h0a41,41,0,0,0,4.591.628c4.823.454,3.821-1.332,3.815-10.823.12-8.844,1.081-26.212,1.081-29.434,0-3.436,1.093-4.06.625-5.777s1.249-9.525,2.966-15.3,3.748-12.022,3.748-12.022-.853-7.986-.97-9.86S540.2,329.7,540.2,329.7Z",
    transform: "translate(-500.478 -307.747)",
    fill: "#001e7f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(22.244 31.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M546.379,225.432c-8.432,4.138-9.754,3.978-13.382,5.855s-4.027,21.626-4.027,24.671-.039,15.146-.741,18.424-3.4,15.458-4.333,17.332-2.694,5.035-.469,6.909,7.128,3.162,18.027,2.46,23.078-7.378,23.663-8.315-3.865-18.152-3.865-21.43a42.891,42.891,0,0,0-.7-7.261c-.234-1.522,3.736-8.666,4.62-13.233s6.763-17.166,5.989-19.474-9.228-4.879-14.9-7.814S546.379,225.432,546.379,225.432Z",
    transform: "translate(-522.347 -215.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M548.184,229.766a6.089,6.089,0,0,0,.115,1.481,3.523,3.523,0,0,0,.516,1.339,2.7,2.7,0,0,0,2.353,1.249,7.828,7.828,0,0,0,2.836-.567c.931-.335,1.82-.786,2.73-1.218-.406.3-.828.569-1.247.852-.447.232-.88.5-1.346.7a6.935,6.935,0,0,1-2.989.7l-.4-.019-.392-.089a2.8,2.8,0,0,1-.752-.286,2.768,2.768,0,0,1-1.1-1.141A4.337,4.337,0,0,1,548.184,229.766Z",
    transform: "translate(-526.078 -216.275)",
    fill: "#dcedff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M569.514,296.586c.586-.937-3.865-18.152-3.865-21.43a42.868,42.868,0,0,0-.7-7.26c-.234-1.523,3.736-8.667,4.62-13.234a25.9,25.9,0,0,1,.854-3.015l-3.467-2.731c-2.586,6-4.694,16.537-6.919,19.113s-7.378,3.631-7.378,3.631,4.929,1.171,7.148.7c0,0,1.661,9.252,1.355,13.818s-1.233,11.477-1.355,12.414c-.045.35-.056,1.569-.053,2.959C565.157,299.473,569.184,297.115,569.514,296.586Z",
    transform: "translate(-526.745 -219.054)",
    fill: "#dcedff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M559.819,213.985c-.272,4.887-.194,8.244.821,9.181,0,0-2.452,8.109-9.836,7.417-2.5-.234-1.953-4.451-.547-6.4l-.312-5.994Z",
    transform: "translate(-526.224 -213.985)",
    fill: "#ffc5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M560.285,222.3h0c-.527-1.5-.534-4.42-.317-8.32l-9.875,4.2.2,3.844h0C551.934,222.792,560.285,222.3,560.285,222.3Z",
    transform: "translate(-526.373 -213.985)",
    fill: "#fe8a8b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(43.563 47.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M583.034,260.217c1.483,2.264,3.278,7.885,2.264,10.461s-10.383,14.053-14.6,18.347-5.152,5-5.933,6.4a74.736,74.736,0,0,1-5.465,8.08,4.718,4.718,0,0,1-2.518,1,4.443,4.443,0,0,1-3.5,1.054,14.115,14.115,0,0,1-3.64,1.7s-.586.994-1.112,1.083-1.113-.966,0-3.074,2.752-2.986,3.1-4.333a29.694,29.694,0,0,1,1.77-4.094s-2.941,2.806-4.639,2.982-1.853-.82-.868-1.64a23.871,23.871,0,0,0,3.5-3.631,7.054,7.054,0,0,1,4.86-2.927c2.166-.293,3.689-.527,4.274-.937A40.9,40.9,0,0,0,566.439,282c2.23-4.294,4.345-9.782,9.568-14.6l-1.873-3.748Z",
    transform: "translate(-547.284 -236.744)",
    fill: "#ffc5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M550.146,313.9a9.955,9.955,0,0,1,2.245-3.1l.357-.327c.106-.1.288-.231.331-.292.184-.214.35-.5.529-.75.348-.527.687-1.063,1.067-1.581a14.17,14.17,0,0,1-.755,1.761,5.834,5.834,0,0,1-.5.851,3.892,3.892,0,0,1-.368.35l-.337.324c-.453.432-.886.887-1.322,1.34S550.554,313.4,550.146,313.9Z",
    transform: "translate(-547.7 -243.656)",
    fill: "#fe8a8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M554.438,312.183c.368-.631.791-1.177,1.175-1.752.4-.567.757-1.135,1.128-1.762A3.865,3.865,0,0,1,556,310.7,5.167,5.167,0,0,1,554.438,312.183Z",
    transform: "translate(-548.322 -243.775)",
    fill: "#fe8a8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M556.421,312.256a4.212,4.212,0,0,0,1.688-.9,4.718,4.718,0,0,0,2.518-1,25.169,25.169,0,0,0,2.164-2.909c-.019.021-1.078,1.087-1.847,1.967a2.5,2.5,0,0,1-2.48.829l.274-1.141S557.6,311.7,556.421,312.256Z",
    transform: "translate(-548.61 -243.599)",
    fill: "#fe8a8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M588.246,269.105c-.124,1.069-.2,1.918-1.988,4.722-2.013,3.155-13.7,16.453-16.22,18.913s-2.459,2.615-4.126,6.5c.7-1.1,1.3-2.056,1.556-2.524.781-1.405,1.717-2.108,5.933-6.4s13.585-15.77,14.6-18.347A6.488,6.488,0,0,0,588.246,269.105Z",
    transform: "translate(-549.988 -238.034)",
    fill: "#fe8a8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M581.986,265.472l.765,1.452a5.431,5.431,0,0,0-2.121,1.205l-1.489-2.884Z",
    transform: "translate(-551.907 -237.474)",
    fill: "#fe8a8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M570.858,252.82c-1.918-4.4-2.294-11.549,0-15.312s6.207-5.116,7.11-4.665,3.01,6.32,5.192,9.029,8.126,10.308,8.277,10.948-5.118,5.8-14.6,9.593C575.711,262.864,570.858,252.82,570.858,252.82Z",
    transform: "translate(-550.476 -232.759)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M577.453,258.579l1.249,3.01s-6.7-7.25-9.314-12.66a20.612,20.612,0,0,0,1.487,6.237s4.853,10.044,5.982,9.593c1.622-.649,3.111-1.339,4.48-2.038Z",
    transform: "translate(-550.492 -235.106)",
    fill: "#dcedff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(35.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M563.142,202.356c1.723-4.208,3.831-8.657,1.176-11,0,0,2.966-.937,4.527-.624a12.151,12.151,0,0,0-4.684-1.25s.614-7.1-1.02-10.149c0,0,.005,3.123-.854,4.372a10.692,10.692,0,0,0-6.792-5.075c-5.075-1.4-9.993-1.561-13.506,2.03s-7.627,8.2-1.705,15.145a27.72,27.72,0,0,0,17.086,9.213C560.727,205.488,563.142,202.356,563.142,202.356Z",
    transform: "translate(-537.294 -177.704)",
    fill: "#252384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M546.356,190.931a18.927,18.927,0,0,0,3.609,1.138c1.227.277,2.461.525,3.7.717s2.49.36,3.741.478a16.517,16.517,0,0,0,3.778,0,9.385,9.385,0,0,1-3.8.728,22.552,22.552,0,0,1-7.625-1.227A10.142,10.142,0,0,1,546.356,190.931Z",
    transform: "translate(-538.609 -179.624)",
    fill: "#0c0835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M560.428,197.588c1.353-.335,3.6-2.5,3.6-2.5s-2.324,1.642-7.1,1.251a40.71,40.71,0,0,1-7.97-1.384s4.925,2.89,6.74,3.356S560.428,197.588,560.428,197.588Z",
    transform: "translate(-538.986 -180.207)",
    fill: "#0c0835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M542.438,194.259c-2.218-1.1-2.863.016-2.863.953a9.882,9.882,0,0,0,1.04,2.931Z",
    transform: "translate(-537.625 -180.041)",
    fill: "#0c0835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M569.217,198.363a20.013,20.013,0,0,1-5.716,6.218s-1.541,2.078.189,2.921c.072.035.153.066.232.1a8.236,8.236,0,0,0,2.931-2.246A31.542,31.542,0,0,0,569.217,198.363Z",
    transform: "translate(-541.005 -180.702)",
    fill: "#0c0835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M560.246,204s1.815-1.346,3.044,0-1.112,7.613-3.864,6.09c0,0-4.567,5.8-7.729,7.436s-5.27.82-6.324-.351-4.59-5.974-4.919-11.066c-.117-1.815.41-5.387.41-6.147s-.469-3.748.175-4.626a2.475,2.475,0,0,1,1.523-1,24.8,24.8,0,0,0,7.319,2.225,13.279,13.279,0,0,1-2.167-1.7s6.734,2.342,11.477,2.635a26.28,26.28,0,0,0,.175,3.864A15.586,15.586,0,0,0,560.246,204Z",
    transform: "translate(-537.75 -180.118)",
    fill: "#ffc5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M565.98,207.463c-.163-1.148-1.126-1.375-1.913-.574a6.2,6.2,0,0,0-.957,3.8c.164.383,1.449.356,1.75-.437s-.41-1.29-1.148-1.055a2.83,2.83,0,0,1,.526-1.9c.644-.745,1.237-.46,1.374-.268A5.292,5.292,0,0,0,565.98,207.463Z",
    transform: "translate(-541.034 -181.871)",
    fill: "#fe8a8b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(4.506 18.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M556.961,201.413a9.077,9.077,0,0,0-.827-.726,5.611,5.611,0,0,0-.951-.589,3.062,3.062,0,0,0-1.074-.37,2.361,2.361,0,0,0-1.128.148v.052a5.3,5.3,0,0,0,.528.174l.506.143c.328.1.674.128,1.006.242a6.865,6.865,0,0,1,.97.422c.32.162.626.353.935.545Z",
    transform: "translate(-544.077 -199.118)",
    fill: "#0c0835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M542.594,200a4.056,4.056,0,0,1,1.017-.36,5.517,5.517,0,0,1,1.056-.124c.356-.008.7.065,1.052.062a10.241,10.241,0,0,0,1.1-.027l.015-.05a2.508,2.508,0,0,0-1.058-.445,3.288,3.288,0,0,0-1.142.041,4.758,4.758,0,0,0-1.1.292,3.751,3.751,0,0,0-.968.567Z",
    transform: "translate(-542.565 -199.017)",
    fill: "#0c0835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M553.394,203.965c.049-.5.326-.874.618-.845s.49.454.441.95-.326.873-.619.844S553.344,204.46,553.394,203.965Z",
    transform: "translate(-544.135 -199.612)",
    fill: "#0c0835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M544.3,203.232c.049-.495.282-.877.521-.854s.393.445.345.94-.283.877-.522.854S544.248,203.728,544.3,203.232Z",
    transform: "translate(-542.815 -199.504)",
    fill: "#0c0835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M549.71,209.736a2.209,2.209,0,0,1-2.414-.024,1.02,1.02,0,0,0,.562.889,1.51,1.51,0,0,0,1.127-.061C549.337,210.383,549.472,210.04,549.71,209.736Z",
    transform: "translate(-543.252 -200.569)",
    fill: "#fe8a8b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(2.153 11.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M551.891,213.062a66.589,66.589,0,0,1-6.807-.457c.384,1.655,1.589,3.29,3.438,3.29A3.806,3.806,0,0,0,551.891,213.062Z",
    transform: "translate(-545.084 -212.605)",
    fill: "#c31f2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M550.474,215.761a2.927,2.927,0,0,0-1.576-.015,2.448,2.448,0,0,0-2.1-.207,2.948,2.948,0,0,0,3.679.222Z",
    transform: "translate(-545.332 -213.011)",
    fill: "#fb8384"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M546.183,214a8.05,8.05,0,0,0,5.03-.194c.028-.244.065-.491.1-.737-1.612-.034-4.211-.23-5.6-.386A4.373,4.373,0,0,0,546.183,214Z",
    transform: "translate(-545.176 -212.616)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(67.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(4.274 4.274)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M599.927,186.368a16.6,16.6,0,0,1,1.224-2.607,6.123,6.123,0,0,1,1.964-2.028,7.951,7.951,0,0,1,3.4-1.105q.653-.088,1.852-.2a18.925,18.925,0,0,0,2.493-.41,8.483,8.483,0,0,0,2.33-.888,3.054,3.054,0,0,0,1.422-1.617,2.235,2.235,0,0,0,.056-1.452,2.887,2.887,0,0,0-.771-1.261,3.859,3.859,0,0,0-1.355-.838,3.414,3.414,0,0,0-2.168-.155,5.334,5.334,0,0,0-1.717.829c-.493.363-.933.659-1.318.893l-4.416-6.489a10.266,10.266,0,0,1,3.658-2.562,11.536,11.536,0,0,1,4.4-.848,13.44,13.44,0,0,1,4.722.877,14.831,14.831,0,0,1,3.591,1.947,11.447,11.447,0,0,1,2.86,3.018,9.145,9.145,0,0,1,1.4,4.042,10.944,10.944,0,0,1-.763,5.026,13.2,13.2,0,0,1-1.037,2.188,8.29,8.29,0,0,1-1.426,1.791,8.57,8.57,0,0,1-1.912,1.358,10.688,10.688,0,0,1-2.452.908,20.913,20.913,0,0,1-3.568.576,18.374,18.374,0,0,0-3.072.452,2.259,2.259,0,0,0-1.707,1.41Zm-3.187,9.051.164-.444a4.1,4.1,0,0,1,5.268-2.417h0a4.1,4.1,0,0,1,2.417,5.268l-.165.444a4.1,4.1,0,0,1-5.267,2.417h0A4.1,4.1,0,0,1,596.74,195.419Z",
    transform: "translate(-582.202 -165.627)",
    fill: "#00264f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M583.993,187.7a12.119,12.119,0,0,1-.14-2.1,4.468,4.468,0,0,1,.537-1.988,5.793,5.793,0,0,1,1.777-1.906c.256-.191.626-.454,1.109-.784a13.8,13.8,0,0,0,1.446-1.143,6.2,6.2,0,0,0,1.173-1.39,2.225,2.225,0,0,0,.335-1.534,1.625,1.625,0,0,0-.476-.946,2.1,2.1,0,0,0-.938-.532,2.816,2.816,0,0,0-1.161-.056,2.493,2.493,0,0,0-1.438.667,3.894,3.894,0,0,0-.8,1.136c-.186.406-.362.75-.526,1.034l-5.11-2.579a7.479,7.479,0,0,1,1.428-2.927,8.4,8.4,0,0,1,2.507-2.1,9.786,9.786,0,0,1,3.323-1.109,10.788,10.788,0,0,1,2.98-.027,8.342,8.342,0,0,1,2.89.915,6.683,6.683,0,0,1,2.322,2.084,8,8,0,0,1,1.289,3.476,9.653,9.653,0,0,1,.111,1.762,6.05,6.05,0,0,1-.277,1.646,6.268,6.268,0,0,1-.74,1.542,7.817,7.817,0,0,1-1.244,1.446,15.222,15.222,0,0,1-2.073,1.629,13.438,13.438,0,0,0-1.8,1.374,1.646,1.646,0,0,0-.591,1.5Zm1.164,6.9-.051-.341a2.989,2.989,0,0,1,2.507-3.4h0a2.989,2.989,0,0,1,3.4,2.507l.052.341a2.99,2.99,0,0,1-2.507,3.4h0A2.99,2.99,0,0,1,585.157,194.6Z",
    transform: "translate(-579.778 -166.165)",
    fill: "#00264f"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(14.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M594.927,181.368a16.589,16.589,0,0,1,1.224-2.607,6.123,6.123,0,0,1,1.964-2.028,7.951,7.951,0,0,1,3.4-1.105q.653-.088,1.852-.2a18.93,18.93,0,0,0,2.493-.41,8.482,8.482,0,0,0,2.33-.888,3.054,3.054,0,0,0,1.422-1.617,2.235,2.235,0,0,0,.056-1.452,2.887,2.887,0,0,0-.771-1.261,3.859,3.859,0,0,0-1.355-.838,3.414,3.414,0,0,0-2.168-.155,5.334,5.334,0,0,0-1.717.829c-.493.363-.933.659-1.318.893l-4.416-6.489a10.266,10.266,0,0,1,3.658-2.562,11.536,11.536,0,0,1,4.4-.848,13.44,13.44,0,0,1,4.722.877,14.831,14.831,0,0,1,3.591,1.947,11.447,11.447,0,0,1,2.86,3.018,9.146,9.146,0,0,1,1.4,4.042,10.945,10.945,0,0,1-.763,5.026,13.2,13.2,0,0,1-1.037,2.188,8.29,8.29,0,0,1-1.426,1.791,8.571,8.571,0,0,1-1.912,1.358,10.688,10.688,0,0,1-2.452.908,20.915,20.915,0,0,1-3.568.576,18.372,18.372,0,0,0-3.072.452,2.259,2.259,0,0,0-1.707,1.41Zm-3.187,9.051.164-.444a4.1,4.1,0,0,1,5.268-2.417h0a4.1,4.1,0,0,1,2.417,5.268l-.165.444a4.1,4.1,0,0,1-5.267,2.417h0A4.1,4.1,0,0,1,591.74,190.419Z",
    transform: "translate(-591.483 -160.627)",
    fill: "#f97068"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(0 3.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M578.993,182.7a12.119,12.119,0,0,1-.14-2.1,4.468,4.468,0,0,1,.537-1.988,5.793,5.793,0,0,1,1.777-1.906c.257-.191.626-.454,1.109-.784a13.8,13.8,0,0,0,1.446-1.143,6.2,6.2,0,0,0,1.173-1.39,2.225,2.225,0,0,0,.335-1.534,1.625,1.625,0,0,0-.476-.946,2.1,2.1,0,0,0-.938-.532,2.817,2.817,0,0,0-1.161-.056,2.493,2.493,0,0,0-1.438.667,3.894,3.894,0,0,0-.8,1.136c-.186.406-.362.75-.526,1.034l-5.11-2.579a7.479,7.479,0,0,1,1.428-2.927,8.4,8.4,0,0,1,2.507-2.1,9.786,9.786,0,0,1,3.323-1.109,10.789,10.789,0,0,1,2.98-.027,8.341,8.341,0,0,1,2.89.915,6.683,6.683,0,0,1,2.322,2.084,8,8,0,0,1,1.289,3.476,9.659,9.659,0,0,1,.111,1.762,6.047,6.047,0,0,1-.277,1.646,6.267,6.267,0,0,1-.74,1.542,7.816,7.816,0,0,1-1.244,1.446,15.219,15.219,0,0,1-2.073,1.629,13.436,13.436,0,0,0-1.8,1.374,1.646,1.646,0,0,0-.591,1.5Zm1.164,6.9-.051-.341a2.989,2.989,0,0,1,2.507-3.4h0a2.989,2.989,0,0,1,3.4,2.507l.052.341a2.99,2.99,0,0,1-2.507,3.4h0A2.99,2.99,0,0,1,580.157,189.6Z",
    transform: "translate(-574.778 -164.335)",
    fill: "#f97068"
  }))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(122.116 277.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(389.51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(0 15.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M609.09,402.039c4.153.007,7.659-4.27,7.563-9.344a36.608,36.608,0,0,0-1.456-9.646c-2.077-7.034-6.357-13.834-4.812-21.264.636-3.06,2.247-5.89,2.292-9.016.047-3.222-1.578-6-3.194-8.45A143.266,143.266,0,0,0,600.9,332.6c-.739,6.987-4.095,13.209-6.429,19.734s-3.543,14.542-.225,20.073c2.37,3.95,6.854,6.328,7.373,11.262.212,2.01-.319,4.056-.432,6.1-.321,5.811,3.253,11.358,7.906,12.273Z",
    transform: "translate(-592.202 -332.601)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(3.269 11.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M614.149,413.4l-1.8-8.351c-.44-2.8-.911-5.6-1.435-8.393-1.036-5.579-2.235-11.131-3.733-16.592-.382-1.363-.774-2.724-1.211-4.065-.209-.674-.447-1.338-.675-2-.246-.651-.492-1.309-.7-2.053a20.135,20.135,0,0,1-.6-4.339c-.08-1.443-.059-2.876-.035-4.307.076-2.858.261-5.7.367-8.528a37.256,37.256,0,0,0,.173-8.478,33.777,33.777,0,0,1,.951,8.519c-.108,2.853-.292,5.688-.366,8.515-.024,1.412-.044,2.825.034,4.221a19,19,0,0,0,.563,4.091c.175.626.423,1.3.68,1.979.233.678.474,1.354.686,2.037.445,1.362.84,2.735,1.225,4.109,1.511,5.508,2.715,11.085,3.755,16.687.531,2.8.991,5.611,1.45,8.421C613.735,407.716,614,410.554,614.149,413.4Z",
    transform: "translate(-597.173 -346.293)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M599.469,356.455c.816.569,1.552,1.152,2.318,1.726.376.291.72.634,1.1.94a5.051,5.051,0,0,0,1.22.769l-.135.016c.462-.431.876-.917,1.329-1.358s.922-.861,1.4-1.275a18.608,18.608,0,0,1,3.136-2.144l.048.057a18.566,18.566,0,0,1-2.672,2.7c-.492.394-1,.772-1.505,1.147s-1.068.687-1.574,1.064l-.072.054-.064-.038a14.572,14.572,0,0,0-1.307-.683,8.056,8.056,0,0,1-1.3-.718,6.753,6.753,0,0,1-1.973-2.21Z",
    transform: "translate(-596.517 -347.575)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M596.064,370.128a18.2,18.2,0,0,1,2,.8,13.456,13.456,0,0,1,1.885,1.01A11.708,11.708,0,0,0,601.819,373c.652.29,1.352.482,2.023.714l-.337.077a33.449,33.449,0,0,1,2.155-2.581,23.361,23.361,0,0,1,2.483-2.293l.056.05a23.353,23.353,0,0,1-1.963,2.752,33.291,33.291,0,0,1-2.289,2.463l-.166.166-.172-.089c-.642-.334-1.246-.732-1.891-1.045a16.18,16.18,0,0,0-2-.8,9.944,9.944,0,0,1-1.936-.944,11.413,11.413,0,0,1-1.754-1.275Z",
    transform: "translate(-596.026 -349.576)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M605.552,388.292a5.462,5.462,0,0,1,1.634.443c.247.118.473.3.723.427a1.44,1.44,0,0,0,.785.176l-.109.053c.17-.3.3-.632.486-.923s.367-.58.578-.85a5.986,5.986,0,0,1,1.554-1.387l.059.046a6.015,6.015,0,0,1-.985,1.835c-.213.268-.459.51-.692.761s-.531.452-.783.689l-.065.06-.044-.007a7.694,7.694,0,0,0-.874-.141,3.847,3.847,0,0,1-.877-.121,3.2,3.2,0,0,1-1.427-1Z",
    transform: "translate(-597.403 -352.089)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M607.1,403.75a8.875,8.875,0,0,1,1.214-.006,5.785,5.785,0,0,1,1.174.138,5.883,5.883,0,0,0,1.181.243,4.366,4.366,0,0,0,1.19-.133l-.134.049a8.068,8.068,0,0,1,.8-.755,8.324,8.324,0,0,1,.857-.683,8.7,8.7,0,0,1,1.967-1.033l.045.06a8.7,8.7,0,0,1-1.539,1.6,13.681,13.681,0,0,1-1.843,1.2l-.109.052-.026,0a8.322,8.322,0,0,0-1.218-.123c-.4-.007-.812.084-1.224.115a4.139,4.139,0,0,1-2.359-.648Z",
    transform: "translate(-597.63 -354.315)",
    fill: "#ffa6a4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(13.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M615.259,402.14c2.869,2.955,7.391-.652,10.373-4.072,3.749-4.3,7.78-9.269,8.216-15.347.164-2.283-.21-4.554.13-6.826.781-5.213,4.96-8.838,6.94-13.66,2.87-6.992.645-14.973-2.12-21.434-1.814-4.238-3.911-8.648-3.571-13.632.311-4.553,2.607-8.681,4.819-12.539-5.169.31-10.995.992-14.629,5.927-3.446,4.679-3.623,11.478-3.294,17.488s.867,12.47-1.664,17.93c-3.435,7.416-11.98,11.8-12.215,20.045-.118,4.161,2.091,7.529,3.6,11.075a15.106,15.106,0,0,1,1.19,7.839c-.425,2.722.246,5.409,1.953,6.959Z",
    transform: "translate(-608.24 -314.631)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(6.485 7.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M615.883,415.474c.319-1.989.686-3.964,1.022-5.941.308-1.983.641-3.959.881-5.943a81.1,81.1,0,0,0,1.558-11.812c.107-1.981.068-3.953.078-5.989a24.921,24.921,0,0,1,.756-6.145,43.04,43.04,0,0,1,2.011-5.8,43.983,43.983,0,0,1,2.837-5.429c2.082-3.48,4.74-6.6,5.574-10.308a15.872,15.872,0,0,0,.162-5.689c-.31-1.9-.8-3.862-1.222-5.835a65.81,65.81,0,0,1-1.711-12.056,23.082,23.082,0,0,1,1.028-6.086,16.044,16.044,0,0,1,2.9-5.338,17.345,17.345,0,0,0-2.1,5.546,21.887,21.887,0,0,0-.241,5.85,64.521,64.521,0,0,0,1.676,11.749c.413,1.953.9,3.88,1.242,5.947a17.448,17.448,0,0,1-.186,6.271,18.879,18.879,0,0,1-2.516,5.716c-1.077,1.738-2.22,3.373-3.251,5.063a42.43,42.43,0,0,0-2.734,5.231,41.611,41.611,0,0,0-1.929,5.563,23.3,23.3,0,0,0-.707,5.771c-.01,1.976.03,4.019-.08,6.047a85.49,85.49,0,0,1-1.572,12.041C618.354,407.81,617.185,411.666,615.883,415.474Z",
    transform: "translate(-615.834 -323.099)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M634.778,334.917a6.425,6.425,0,0,1-.671,1.774,4.985,4.985,0,0,1-1.1,1.487,5.489,5.489,0,0,0-1.222,1.4c-.315.53-.509,1.141-.779,1.7l-.247.515-.538-.455c-.358-.3-.7-.622-1.04-.943a8.69,8.69,0,0,1-.946-1.028,10.613,10.613,0,0,1-1.482-2.437l.09-.082a10.582,10.582,0,0,1,2.311,1.671,8.7,8.7,0,0,1,.95,1.026c.293.364.583.731.857,1.112l-.785.059c.419-.459.914-.867,1.288-1.357a5.522,5.522,0,0,0,.845-1.656,4.962,4.962,0,0,1,.969-1.572,6.467,6.467,0,0,1,1.4-1.285Z",
    transform: "translate(-617.412 -324.804)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M639.841,355.181a6.925,6.925,0,0,1-.828,2.621,7.372,7.372,0,0,1-1.681,2.153c-.705.59-1.434,1.122-2.059,1.762-.651.618-1.213,1.321-1.915,1.942l-.367.324-.332-.492L631.5,361.77c-.392-.57-.771-1.144-1.129-1.731l-1.092-1.746a18.536,18.536,0,0,0-1.184-1.711l.071-.1a6.166,6.166,0,0,1,1.8,1.235,12.389,12.389,0,0,1,1.436,1.609,13.059,13.059,0,0,1,1.158,1.794c.339.627.669,1.248.95,1.913l-.7-.169a12.473,12.473,0,0,0,2.2-1.43,8.035,8.035,0,0,0,1.658-2.052c.46-.75.987-1.42,1.5-2.109s.991-1.4,1.55-2.136Z",
    transform: "translate(-617.606 -327.749)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M633.669,378.81a8.626,8.626,0,0,1-2.328,2.107A10.32,10.32,0,0,1,628.5,382.2c-1.012.262-2.04.421-3.013.743-.985.294-1.932.688-2.94,1.005l-.207.065-.221-.22a16.365,16.365,0,0,1-1.667-2.034,13.243,13.243,0,0,1-1.338-2.267,11.739,11.739,0,0,1-.853-2.515,7.093,7.093,0,0,1-.068-2.654l.121,0a14.893,14.893,0,0,0,.817,2.383c.32.763.726,1.487,1.11,2.218l1.234,2.17c.418.721.891,1.428,1.334,2.125l-.427-.154a15.608,15.608,0,0,0,3-.479,12.63,12.63,0,0,0,2.783-1.234c.883-.5,1.8-.871,2.707-1.293s1.783-.875,2.719-1.344Z",
    transform: "translate(-616.155 -330.533)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M626.384,400.584a3.834,3.834,0,0,1-1.318,1.122,4.563,4.563,0,0,1-1.63.537,11,11,0,0,1-1.71-.085,12.022,12.022,0,0,0-1.676.04l-.069,0-.125-.117a14.142,14.142,0,0,1-1.275-1.265c-.386-.45-.785-.891-1.128-1.373a12.958,12.958,0,0,1-.921-1.526,9.823,9.823,0,0,1-.705-1.685l.1-.072a9.917,9.917,0,0,1,1.4,1.175,12.981,12.981,0,0,1,1.183,1.333c.358.471.661.983.975,1.486a14.327,14.327,0,0,1,.828,1.594l-.193-.112a3.542,3.542,0,0,0,1.586.077,12.193,12.193,0,0,0,1.527-.505c.5-.149,1-.25,1.5-.372.516-.105,1.006-.263,1.588-.358Z",
    transform: "translate(-615.826 -333.702)",
    fill: "#f97068"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(3.857 81.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M629.572,443.325h-25.7a3.043,3.043,0,0,1-3.008-2.585l-4.113-27a3.044,3.044,0,0,1,3.009-3.5h33.926a3.044,3.044,0,0,1,3.009,3.5l-4.113,27A3.043,3.043,0,0,1,629.572,443.325Z",
    transform: "translate(-596.714 -410.238)",
    fill: "#b4dff9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M638.371,410.238h-5.247a3.044,3.044,0,0,1,3.009,3.5l-4.113,27a3.043,3.043,0,0,1-3.008,2.585h5.247a3.043,3.043,0,0,0,3.008-2.585l4.113-27A3.044,3.044,0,0,0,638.371,410.238Z",
    transform: "translate(-601.401 -410.238)",
    fill: "#a2d4f9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(0 16.387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(20.377 17.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M183.835,358.611a5.264,5.264,0,0,1-.628,3.181,22.846,22.846,0,0,0-2.807,11.656c.084,2.664.631,5.388-.094,7.953-1.252,4.424-5.921,7.16-7.423,11.5-1.332,3.852-.093,8.7-2.862,11.688a2.586,2.586,0,0,1-2.689.934,3.276,3.276,0,0,1-1.159-.963c-3.174-3.605-6.572-7.986-5.593-12.689.92-4.417,5.472-7.4,6.335-11.832.705-3.619-1.145-7.794.928-10.842.573-.841,1.391-1.484,2.017-2.287,2.465-3.167,1.552-8.213,4.393-11.047a6.547,6.547,0,0,1,3.349-1.718,5.2,5.2,0,0,1,6.235,4.462Z",
    transform: "translate(-160.407 -354.034)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(5.017 5.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M166.635,415.744c-.19-2.356-.272-4.714-.359-7.078.107-2.355.233-4.712.434-7.067s.467-4.71.883-7.05a29.978,29.978,0,0,1,1.961-6.889c1.709-4.322,3.091-8.841,4.487-13.32l2.024-6.752q1.249-3.308,2.429-6.642c-.344,2.341-.88,4.641-1.349,6.957l-2.029,6.766c-1.4,4.5-2.773,8.993-4.525,13.423a28.825,28.825,0,0,0-1.891,6.653c-.408,2.291-.67,4.617-.869,6.949s-.334,4.674-.423,7.019Z",
    transform: "translate(-166.276 -360.946)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M180.325,368.828a5.517,5.517,0,0,1-1.427,1.419,8.3,8.3,0,0,1-.9.457,3.431,3.431,0,0,0-.82.567l-.108.1-.095-.146c-.225-.344-.5-.663-.714-1.01s-.426-.7-.61-1.063a8.31,8.31,0,0,1-.763-2.352l.068-.033a8.3,8.3,0,0,1,1.411,2.029c.179.367.322.751.477,1.128s.237.793.374,1.18l-.2-.05a3.439,3.439,0,0,0,.783-.615,8.279,8.279,0,0,1,.7-.724,5.54,5.54,0,0,1,1.779-.945Z",
    transform: "translate(-167.526 -361.79)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M179.109,378.217c-.405.333-.822.694-1.259,1a10.436,10.436,0,0,1-1.36.847c-.485.233-1,.416-1.465.68a9,9,0,0,0-1.315.926l-.147.12-.149-.195a23.468,23.468,0,0,1-1.72-2.663,16.783,16.783,0,0,1-1.242-2.933l.065-.037a16.84,16.84,0,0,1,1.871,2.577,23.467,23.467,0,0,1,1.393,2.848l-.3-.075a9.632,9.632,0,0,0,1.411-.772c.444-.3.84-.678,1.268-1.005a9.273,9.273,0,0,1,1.386-.817,6.183,6.183,0,0,1,1.542-.569Z",
    transform: "translate(-166.882 -363.125)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M175.8,390.948a6.788,6.788,0,0,1-1.449,1.074,5.5,5.5,0,0,1-1.647.655,4.257,4.257,0,0,0-1.593.764c-.473.359-.935.755-1.409,1.065l-.357.234-.266-.4a11.281,11.281,0,0,1-1.023-1.843,9.812,9.812,0,0,1-.66-2.043l.082-.045a9.813,9.813,0,0,1,1.371,1.652,11.189,11.189,0,0,1,1.009,1.852l-.622-.164a10.615,10.615,0,0,1,1.683-.669,4.856,4.856,0,0,0,1.553-.866,5.05,5.05,0,0,1,1.534-.91,6.227,6.227,0,0,1,1.755-.442Z",
    transform: "translate(-166.439 -365.222)",
    fill: "#ffa6a4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M158.577,412.265c-1.841-.3-8.746-2.512-8.264-4.315,2.071-7.738,4.14-16.517-3.028-20.3-3.449-1.821-7.778-2.747-9.742-6.117-2.023-3.471-.533-7.883,1.282-11.467s4-7.42,3.223-11.361c-.815-4.127-4.718-7.172-5.342-11.333-.852-5.681,4.663-10.258,9.963-12.475a9.339,9.339,0,0,1,5.682-.94,6.982,6.982,0,0,1,3.464,2.237c3.722,4.162,3.57,10.442,2.72,15.961s-2.149,11.347-.07,16.529c1.476,3.681,4.637,7.143,3.791,11.019-.339,1.552-1.307,2.906-1.676,4.451-.994,4.166,2.465,7.918,4.051,11.9a14.6,14.6,0,0,1-3.237,15.3,3.235,3.235,0,0,1-2.816.921Z",
    transform: "translate(-136.572 -333.8)",
    fill: "#ffa6a4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(4.723 8.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M160.825,413.874c-.426-3.063-.852-6.116-1.4-9.146-.13-.758-.289-1.511-.411-2.269s-.183-1.523-.309-2.28q-.342-2.275-.773-4.531a59.555,59.555,0,0,0-2.31-8.833,18.387,18.387,0,0,0-1.931-3.994,5.472,5.472,0,0,0-1.4-1.478,7.342,7.342,0,0,1-1.863-1.732,7.655,7.655,0,0,1-1.344-4.806,23.6,23.6,0,0,1,.69-4.714c.71-3.039,1.6-5.975,2.1-8.964a20.548,20.548,0,0,0-.183-8.874c-.241-.7-.431-1.4-.66-2.113a14.9,14.9,0,0,0-.881-2.064,20.62,20.62,0,0,0-2.579-3.784,17.413,17.413,0,0,1,3.29,3.337,15.686,15.686,0,0,1,1.293,2.014,8.272,8.272,0,0,1,.892,2.239,21.946,21.946,0,0,1,.214,9.477c-.517,3.1-1.426,6.082-2.117,9.046a22.339,22.339,0,0,0-.654,4.423,6.25,6.25,0,0,0,1.069,3.946,5.9,5.9,0,0,0,1.511,1.4,6.81,6.81,0,0,1,1.776,1.851,19.689,19.689,0,0,1,2.094,4.309,60.9,60.9,0,0,1,2.37,9.049c.294,1.525.551,3.055.783,4.588.106.768.249,1.53.342,2.3.078.771.112,1.548.162,2.321C160.768,407.687,160.882,410.781,160.825,413.874Z",
    transform: "translate(-142.892 -344.293)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M148.758,355.029a4.73,4.73,0,0,1,1.386.823,4.979,4.979,0,0,1,1.085,1.14,7.449,7.449,0,0,0,.922,1.284,11.531,11.531,0,0,0,1.206,1.022l-.546.034c.184-.4.411-.768.62-1.148a11.567,11.567,0,0,1,.685-1.1c.238-.358.512-.7.772-1.04s.557-.663.794-1.028l.092.015a3.636,3.636,0,0,1-.273,1.352,8.928,8.928,0,0,1-.561,1.212,8.2,8.2,0,0,1-.722,1.1,12.357,12.357,0,0,1-.834,1.028l-.342.359-.2-.325a9.261,9.261,0,0,0-.9-1.29,6.284,6.284,0,0,0-1.217-.994,5.978,5.978,0,0,1-1.106-1.087,9.646,9.646,0,0,1-.918-1.287Z",
    transform: "translate(-143.055 -345.849)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M155.009,368.579a7.513,7.513,0,0,1-.825,1.458,10.491,10.491,0,0,1-1.055,1.267c-.4.379-.855.7-1.282,1.052a7.681,7.681,0,0,0-1.123,1.2l-.107.14-.15-.121a12.667,12.667,0,0,1-1.44-1.321c-.416-.475-.859-.926-1.246-1.421s-.756-1-1.1-1.526-.663-1.069-1.028-1.58l.053-.078a6.6,6.6,0,0,1,1.56,1.163,14.724,14.724,0,0,1,1.3,1.392c.4.485.746,1.017,1.121,1.521s.674,1.107,1.022,1.54l-.257.02a6.76,6.76,0,0,0,1.134-1.179c.321-.448.608-.924.945-1.353a14.27,14.27,0,0,1,1.13-1.178,12.351,12.351,0,0,1,1.282-1.052Z",
    transform: "translate(-142.613 -347.682)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M142.181,379.029c.581.683,1.184,1.311,1.8,1.912s1.282,1.128,1.928,1.707a6.261,6.261,0,0,0,2.25,1.308,8.294,8.294,0,0,0,2.587.288l-.384.271a17.321,17.321,0,0,1,.612-2.094,11.755,11.755,0,0,1,.89-2,9.8,9.8,0,0,1,1.275-1.8,4.778,4.778,0,0,1,1.793-1.293l.047.08a7.008,7.008,0,0,0-1.293,1.626,20.071,20.071,0,0,0-.968,1.83l-.862,1.9c-.283.637-.532,1.3-.781,1.946l-.12.311-.264-.041a14.859,14.859,0,0,1-2.628-.751,26.656,26.656,0,0,1-2.521-1.035,6.6,6.6,0,0,1-2.121-1.741,6.781,6.781,0,0,1-1.327-2.387Z",
    transform: "translate(-142.097 -349.087)",
    fill: "#f97068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M159.625,387.414a5.234,5.234,0,0,1,.36,2.148,7.058,7.058,0,0,1-.4,2.156,7.71,7.71,0,0,1-1.105,1.882l-1.288,1.713-.091.121-.15-.106a19.029,19.029,0,0,0-2.246-1.265c-.755-.406-1.537-.751-2.32-1.085s-1.563-.679-2.366-.981c-.8-.327-1.617-.587-2.448-.9l.014-.093a12.332,12.332,0,0,1,5.2,1.057,16.3,16.3,0,0,1,2.335,1.3,15.729,15.729,0,0,1,2.055,1.708l-.24.016a5.99,5.99,0,0,0,1.189-1.7,14.75,14.75,0,0,0,.674-1.937,15.287,15.287,0,0,0,.738-4.016Z",
    transform: "translate(-142.891 -350.551)",
    fill: "#f97068"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(7.99 65.423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M172.452,443.339h-19.71a3.96,3.96,0,0,1-3.66-3.722l-3.12-24.245c-.342-2.653,1.393-5.042,3.66-5.042h25.951c2.266,0,4,2.389,3.66,5.042l-3.12,24.245A3.96,3.96,0,0,1,172.452,443.339Z",
    transform: "translate(-145.919 -410.329)",
    fill: "#b4dff9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M179.348,410.329h-4.292c2.267,0,4,2.389,3.66,5.042L175.6,439.616a3.962,3.962,0,0,1-3.661,3.722h4.292a3.96,3.96,0,0,0,3.66-3.722l3.12-24.245C183.349,412.718,181.614,410.329,179.348,410.329Z",
    transform: "translate(-149.694 -410.329)",
    fill: "#a2d4f9"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189",
    transform: "translate(36.955 67.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(0 154.776)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 71.253,
    height: 42.675,
    rx: 6.849,
    transform: "translate(0 0)",
    fill: "#a2d4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M104.364,294.974H40.8a3.844,3.844,0,0,1-3.844-3.844l35.626-23.647,35.626,23.647A3.844,3.844,0,0,1,104.364,294.974Z",
    transform: "translate(-36.955 -252.299)",
    fill: "#b4dff9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M104.364,249.721H40.8a3.845,3.845,0,0,0-3.844,3.844l35.626,23.647,35.626-23.647A3.844,3.844,0,0,0,104.364,249.721Z",
    transform: "translate(-36.955 -249.721)",
    fill: "#fafdff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(340.869 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M585.9,68.671H443.708a8.021,8.021,0,0,0-8.021,8.021v33.257a8.021,8.021,0,0,0,8.021,8.021h14.283l-4.868,12.015,16.184-12.015H585.9a8.021,8.021,0,0,0,8.02-8.021V76.691A8.021,8.021,0,0,0,585.9,68.671Z",
    transform: "translate(-435.688 -68.671)",
    fill: "#a2d4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M579.151,89.215H470.783a1.874,1.874,0,0,1,0-3.748H579.151a1.874,1.874,0,0,1,0,3.748Zm1.874,6.542a1.873,1.873,0,0,0-1.874-1.873H455.733a1.873,1.873,0,1,0,0,3.747H579.151A1.873,1.873,0,0,0,581.025,95.757Zm-54.184,8.417a1.874,1.874,0,0,0-1.874-1.874H455.733a1.873,1.873,0,1,0,0,3.747h69.234A1.874,1.874,0,0,0,526.841,104.174Z",
    transform: "translate(-438.325 -71.108)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M640.323,241.2a16.725,16.725,0,0,0-2.54,20.37l-28.119,28.118a1.475,1.475,0,0,0,0,2.085l3.75,3.75a1.474,1.474,0,0,0,2.085,0l2-2,5.2,5.2a1.475,1.475,0,0,0,2.085,0l3.072-3.072a1.475,1.475,0,0,0,0-2.086l-5.2-5.2,2.69-2.69,4.439,4.439a1.474,1.474,0,0,0,2.085,0l3.072-3.072a1.474,1.474,0,0,0,0-2.085l-4.439-4.439L643.619,267.4a16.726,16.726,0,1,0-3.3-26.206Zm18.426,18.427a9.325,9.325,0,1,1,0-13.188A9.326,9.326,0,0,1,658.75,259.624Z",
    transform: "translate(-120.003 -92.996)",
    fill: "#a2d4f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(37.552 212.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M93.059,354.112a23,23,0,0,1-1.005-3.868,8.509,8.509,0,0,1,.3-3.907A11.024,11.024,0,0,1,95,342.144q.618-.673,1.8-1.859a26.306,26.306,0,0,0,2.3-2.649,11.782,11.782,0,0,0,1.7-3.016,4.243,4.243,0,0,0,.084-2.985,3.1,3.1,0,0,0-1.228-1.6,4.011,4.011,0,0,0-1.942-.663,5.37,5.37,0,0,0-2.189.308,4.742,4.742,0,0,0-2.453,1.758,7.433,7.433,0,0,0-1.1,2.408c-.2.825-.411,1.531-.616,2.122l-10.471-3.011a14.213,14.213,0,0,1,1.633-5.98,16,16,0,0,1,3.944-4.808,18.626,18.626,0,0,1,5.821-3.251,20.546,20.546,0,0,1,5.562-1.107,15.878,15.878,0,0,1,5.729.686,12.7,12.7,0,0,1,5.081,3.072,15.2,15.2,0,0,1,3.643,6.044,18.368,18.368,0,0,1,.834,3.255,11.553,11.553,0,0,1,.066,3.177,11.939,11.939,0,0,1-.838,3.147,14.851,14.851,0,0,1-1.813,3.143,28.917,28.917,0,0,1-3.3,3.78,25.527,25.527,0,0,0-2.879,3.208,3.137,3.137,0,0,0-.573,3.019ZM97.683,366.6l-.218-.62a5.689,5.689,0,0,1,3.481-7.253h0a5.688,5.688,0,0,1,7.253,3.48l.217.62a5.688,5.688,0,0,1-3.48,7.253h0A5.688,5.688,0,0,1,97.683,366.6Z",
    transform: "translate(-80.882 -317.777)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.0ebfc742c833d1f6f6abaa9690e474c4.svg";
export { ForwardRef as ReactComponent };